// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { LanguageSwitchAnchor } from './common/LanguageSwitchAnchor/LanguageSwitchAnchor'
import { LanguageSwitchMenu } from './common/LanguageSwitchMenu/LanguageSwitchMenu'

import { getLanguages } from 'utils/languages'

export const LanguageSwitch = ({ language, onSwitchLanguage, dark }) => {
  const languages = getLanguages()

  const { roundIcon, original } =
    R.find(R.propEq('value', language), languages) ?? {}

  return (
    <Dropdown offsetSize={4}>
      <LanguageSwitchAnchor {...{ icon: roundIcon, original, dark }} />
      <LanguageSwitchMenu {...{ language, languages, onSwitchLanguage }} />
    </Dropdown>
  )
}